export function usePlansApi() {
	const deactivatePlan = async <T = unknown>(
		plan_id: string,
		payload?: Record<string, string[] | string>,
		query?: object
	) => {
		const { data } = await useAPI<IRequestResponse<T>>(`/purchases/${plan_id}/deactivate-plan`, {
			method: 'PUT',
			body: {
				...(payload && Object.keys(payload).length
					? {
							reasons: payload
						}
					: {})
			},
			query
		})
		return data.value
	}
	const changeCustodian = async <T = unknown>(payload: ChangeCustodianPayload) => {
		const url = payload?.is_pending ? '/pending-policies/change-custodian' : '/policies/change-custodian'
		const { data } = await useAPI<IRequestResponse<T>>(url, {
			method: 'POST',
			body: payload
		})
		return data.value
	}
	const editEmployeeInfo = async <T = unknown>(
		payload: Omit<ChangeCustodianPayload, 'pending_policy_id' | 'policy_id' | 'is_pending'> & {
			customer_id: string
			password: string
		}
	) => {
		const { customer_id, ...rest } = payload
		const { data } = await useAPI<IRequestResponse<T>>(`/customers/${customer_id}`, {
			method: 'PATCH',
			body: rest
		})
		return data.value
	}

	/**
     * @description  The necessary parameter required for this function follows the example pattern below
     * @example
		product_id: '',
		file: comprehensive-auto.xlsx,
		cover_period: 'annual'
     **/
	const computeBatchPurchase = async <T = unknown>(payload: FormData) => {
		return await useAPI<IRequestResponse<T>>('/batch-purchase/compute-batch-purchase', {
			method: 'POST',
			body: payload
		})
	}

	/**
	 * @description  The necessary parameter required for this function follows the example pattern below
	 * @example
	 * product_id: "",
	 * file: 'comprehensive-auto.xlsx',
	 * cover_period: 'annual',
	 * payment_channel: 'wallet',
	 * sales_type: 'new purchase'
	 *
	 **/
	const purchaseViaBatch = async <T = BatchPurchaseResponse>(payload: FormData) => {
		return await useAPI<IRequestResponse<T>>('batch-purchase/buy-batch-purchase', {
			method: 'POST',
			body: payload
		})
	}
	/**
	 * @description  The necessary parameter required for this function follows the example pattern below
	 * @example
	 * product_id: "",
	 * file: 'comprehensive-auto.xlsx',
	 **/

	const addCustodianViaBatch = async <T = BatchPurchaseResponse>(payload: FormData) => {
		return await useAPI<IRequestResponse<T>>('/batch/add-employee', {
			method: 'POST',
			body: payload
		})
	}

	return {
		deactivatePlan,
		changeCustodian,
		computeBatchPurchase,
		purchaseViaBatch,
		addCustodianViaBatch,
		editEmployeeInfo
	}
}
